export const platinum = require("../../../../assets/icons/jewelry-metals/platinum.png");
export const rose_gold = require("../../../../assets/icons/jewelry-metals/rose-gold.png");
export const silver = require("../../../../assets/icons/jewelry-metals/silver.png");
export const two_tone = require("../../../../assets/icons/jewelry-metals/two-tone.png");
export const white_gold = require("../../../../assets/icons/jewelry-metals/white-gold.png");
export const yellow_gold = require("../../../../assets/icons/jewelry-metals/yellow-gold.png");
export const stainless_steel = require("../../../../assets/icons/jewelry-metals/stainless-steel.png");
